import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { ShopItemType } from '@sorare/core/src/__generated__/globalTypes';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { HeadlineS } from '@sorare/core/src/atoms/typography';
import { Dialog } from '@sorare/core/src/components/dialog';
import { shopCategories } from '@sorare/core/src/lib/glossary';

import { ShopItemPicker } from 'components/shopItems/ShopItemPicker';

import { ShopItemLogo } from './types';

const DialogContainer = styled(Vertical).attrs({ gap: 2 })`
  padding: var(--triple-unit);
`;

type Props = {
  open: boolean;
  type?:
    | (typeof ShopItemType)['CLUB_BADGE']
    | (typeof ShopItemType)['ACHIEVEMENT_BADGE']
    | (typeof ShopItemType)['BACKGROUND'];
  onSelect?: (shopItem: ShopItemLogo) => void;
  onClose: () => void;
};

export const ShopItemDialog = ({ open, type, onSelect, onClose }: Props) => {
  if (!type || !shopCategories[type]) {
    return null;
  }

  return (
    <Dialog
      open={open}
      maxWidth="sm"
      fullWidth
      onClose={onClose}
      title={
        <HeadlineS as="h5" className="text-center">
          <FormattedMessage {...shopCategories[type]} />
        </HeadlineS>
      }
    >
      <DialogContainer>
        <ShopItemPicker onSelect={onSelect} types={[type]} inDialog hideSort />
      </DialogContainer>
    </Dialog>
  );
};
